@import "../../../../../styles/variables";
@import "../../../../../styles/mixins/box-shadow";

.range_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0;
}

.sliders_control {
  position: relative;
  min-height: 30px;
}

.form_control {
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 24px;
  color: $svs-ultra-light-grey-6;
}

.form_control_container {
  flex: auto;
}

.input-currency--visible {
  position: absolute;
  left: 6px;
  font-size: 14px;
  font-weight: 300;
  font-family: ArialRoundedMTforSE_Latin;
  top: 50%;
  transform: translateY(-50%);
}

.input-currency--hidden {
  display: none;
}

.from-input__wrapper,
.to-input__wrapper {
  width: 100%;
  display: inline-flex;
  position: relative;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: 23px;
  height: 23px;
  background-color: $svs-white;
  border-radius: 50%;
  cursor: pointer;
  @include box-shadow-range-filter;
}

input[type="range"]::-moz-range-thumb {
  -webkit-appearance: none;
  appearance: none;
  pointer-events: all;
  width: 24px;
  height: 24px;
  background-color: $svs-white;
  border-radius: 50%;
  cursor: pointer;
  @include box-shadow-range-filter;
}

input[type="range"]::-webkit-slider-thumb:hover {
  background: $svs-ultra-light-grey-2;
}

input[type="range"]::-webkit-slider-thumb:active {
  box-shadow:
    inset 0 0 3px rgba(0, 0, 0, 0.5),
    0 0 9px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow:
    inset 0 0 3px rgba(0, 0, 0, 0.5),
    0 0 9px rgba(0, 0, 0, 0.5);
}

input[type="number"] {
  appearance: textfield;
  color: $svs-se-dark-grey;
  width: 100%;
  height: 30px;
  font-size: 14px;
  font-family: ArialRoundedMTforSE_Latin;
  line-height: 22px;
  border-radius: 2px;
  border: 1px solid $svs-se-dark-grey;
  padding-left: 14px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  height: 8px;
  width: 100%;
  position: absolute;
  background-color: $svs-ultra-light-grey-2;
  pointer-events: none;
  border-radius: 5px;
}

#fromSlider {
  height: 0;
  z-index: 1;
  top: 3px;
}

#toSlider {
  top: 0;
}
